import React, { useState } from "react";
import { Card, Image, Tag, Divider, Checkbox } from "antd";
import { GlobalOutlined, LockOutlined } from "@ant-design/icons";

const { Meta } = Card;

const ImageCollectionCard = ({ collection, onImageSelect }) => {
  const [failedImages, setFailedImages] = useState({});

  const handleImageError = (imageId) => {
    setFailedImages((prev) => ({ ...prev, [imageId]: true }));
  };

  return (
    <Card
      hoverable
      style={{
        height: "500px",
        overflow: "hidden",
      }}
      extra={
        collection.is_public ? (
          <Tag icon={<GlobalOutlined />} color="green">
            Public
          </Tag>
        ) : (
          <Tag icon={<LockOutlined />} color="red">
            Private
          </Tag>
        )
      }
    >
      <div
        style={{
          height: "300px",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "8px",
          overflowY: "auto",
          padding: "8px",
        }}
      >
        <Image.PreviewGroup>
          {collection.images.map(
            (image) =>
              !failedImages[image.id] && (
                <div key={image.id} style={{ position: "relative" }}>
                  <Image
                    src={image.file_url}
                    alt={image.title}
                    onError={() => handleImageError(image.id)}
                    style={{ objectFit: "cover", marginBottom: "8px" }}
                    preview={{
                      mask: (
                        <div style={{ textAlign: "center" }}>
                          Click to Preview
                        </div>
                      ),
                      maskStyle: { fontSize: "10px" },
                    }}
                  />
                  <Checkbox
                    onChange={(e) => onImageSelect(image, e.target.checked)}
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      transform: "scale(1.4)",
                    }}
                  />
                </div>
              )
          )}
        </Image.PreviewGroup>
      </div>
      <Divider />
      <Meta title={collection?.name || "Untitled Collection"} />
    </Card>
  );
};

export default ImageCollectionCard;
